// ── ModuleLoader ──────────────────────────────────────────────────────────────
// Reusable skeleton loader shown while a module fetches its initial data.
// Usage: if (loading) return <ModuleLoader/>;

export default function ModuleLoader() {
  const pulse = {
    background: 'linear-gradient(90deg, #f0f0f5 25%, #e8e8f0 50%, #f0f0f5 75%)',
    backgroundSize: '200% 100%',
    animation: 'ml-pulse 1.4s ease-in-out infinite',
    borderRadius: 8,
  };

  return (
    <>
      <style>{`
        @keyframes ml-pulse {
          0%   { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>

      <div style={{ padding: '0 0 16px' }}>
        {/* Page title skeleton */}
        <div style={{ ...pulse, height: 22, width: '38%', marginBottom: 6 }}/>
        <div style={{ ...pulse, height: 14, width: '22%', marginBottom: 20 }}/>

        {/* Stat cards row */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)',
          gap: 10, marginBottom: 14 }}>
          {[1, 2].map(i => (
            <div key={i} className="lyt-stat" style={{ pointerEvents: 'none' }}>
              <div>
                <div style={{ ...pulse, height: 11, width: '60%', marginBottom: 8 }}/>
                <div style={{ ...pulse, height: 22, width: '40%', marginBottom: 6 }}/>
                <div style={{ ...pulse, height: 10, width: '50%' }}/>
              </div>
              <div className="lyt-ib"
                style={{ background: '#e8e8f0', boxShadow: 'none' }}/>
            </div>
          ))}
        </div>

        {/* Main card skeleton */}
        <div className="lyt-card" style={{ marginBottom: 10 }}>
          {[80, 60, 70, 55, 65].map((w, i) => (
            <div key={i} style={{ ...pulse, height: 14, width: `${w}%`,
              marginBottom: i < 4 ? 14 : 0 }}/>
          ))}
        </div>

        {/* Second card skeleton */}
        <div className="lyt-card">
          {[90, 50, 75, 40].map((w, i) => (
            <div key={i} style={{ ...pulse, height: 14, width: `${w}%`,
              marginBottom: i < 3 ? 14 : 0 }}/>
          ))}
        </div>
      </div>
    </>
  );
}
